import { NAVColumnsList } from "../../Pages/Dashboard/NavColumnsList";

export function BottomNavbar ({ tab, navigate, isPaid, loading, data }) {
    const navItems = NAVColumnsList.filter(({ feature, key }) => {
      if (key === "fup") return data?.serviceStatus?.fup?.visible === true
      return !feature || data?.profile?.[feature] === true
    })
    return (<>
          <nav className="bottom-nav">
            {navItems.map(({ key, icon, label }) => (
            <button
                key={key}
                className={`bottom-nav-item${tab === key ? " active" : ""}`}
                onClick={() => navigate(key)}
            >
                {key === "billing" && !isPaid && !loading && (
                <span className="bottom-nav-badge" />
                )}
                <span className="bottom-nav-icon">
                    <i className={icon}></i>
                </span>
                <span className="bottom-nav-label">{label}</span>
            </button>
            ))}
        </nav>
    </>)
}
